import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Mail className="w-4 h-4 text-coral-warm" />
            <span>Need help? Contact support:</span>
            <a
              href="mailto:bridgelinks2@gmail.com"
              className="text-coral-warm hover:underline font-medium"
            >
              bridgelinks2@gmail.com
            </a>
          </div>

          <div className="flex items-center gap-3 text-sm">
            <Link
              to="/privacy"
              className="text-gray-600 hover:text-coral-warm transition-colors"
            >
              Privacy Policy
            </Link>
            <span className="text-gray-400">•</span>
            <Link
              to="/terms"
              className="text-gray-600 hover:text-coral-warm transition-colors"
            >
              Terms of Service
            </Link>
            <span className="text-gray-400">•</span>
            <Link
              to="/disclaimer"
              className="text-gray-600 hover:text-coral-warm transition-colors"
            >
              Disclaimer
            </Link>
          </div>
        </div>

        <div className="mt-4 pt-4 border-t border-gray-100">
          <p className="text-center text-sm text-gray-500">
            © {currentYear} Branon by BridgeLinks Enterprises. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
